import { combineReducers } from '@reduxjs/toolkit';
import activityLogsReducer from './activity_logs/slice';
import additionalPortRequestReducer from './additional_port_request/slice';
import appAlertsReducer from './app_alerts/slice';
import applicationReducer from './application/slice';
import auth0Reducer from './auth0/slice';
import chartsReducer from './charts/slice';
import checkboxReducer from './checkbox/slice';
import cloudProvidersReducer from './cloud_providers/slice';
import contactsReducer from './contacts/slice';
import crossConnectionsReducer from './cross_connections/slice';
import customerSpaceRequestReducer from './customer_space_request/slice';
import customersInfoReducer from './customers_info/slice';
import devicesReducer from './devices/slice';
import edgeConnectionsReducer from './edge_connections/slice';
import edgeEventsReducer from './edge_events/slice';
import edgeMarketsReducer from './edge_markets/slice';
import edgeOfferingsReducer from './edge_offerings/slice';
import interceptorsResponseReducer from './interceptors_response/slice';
import inventoryReducer from './inventory/slice';
import ixOverlaysReducer from './ix_overlays/slice';
import kexCommunityReducer from './kex_community/slice';
import kexProfilesReducer from './kex_profiles/slice';
import locationReducer from './location/slice';
import locationsReducer from './locations/slice';
import lockersReducer from './lockers/slice';
import mapboxReducer from './mapbox/slice';
import menusReducer from './menus/slice';
import metricsReducer from './metrics/slice';
import modalAlertsReducer from './modal_alerts/slice';
import networkInterfacesReducer from './network_interfaces/slice';
import networkingOverviewReducer from './networking_overview/slice';
import organizationsReducer from './organizations/slice';
import rolesReducer from './roles/slice';
import userReducer from './user/slice';
import userSettingsReducer from './user_settings/slice';
import usersReducer from './users/slice';
const reducers = combineReducers({
    activityLogs: activityLogsReducer,
    additionalPortRequest: additionalPortRequestReducer,
    appAlerts: appAlertsReducer,
    application: applicationReducer,
    auth0: auth0Reducer,
    charts: chartsReducer,
    checkbox: checkboxReducer,
    cloudProviders: cloudProvidersReducer,
    contacts: contactsReducer,
    crossConnections: crossConnectionsReducer,
    customerSpaceRequest: customerSpaceRequestReducer,
    customersInfo: customersInfoReducer,
    devices: devicesReducer,
    edgeConnections: edgeConnectionsReducer,
    edgeEvents: edgeEventsReducer,
    edgeMarkets: edgeMarketsReducer,
    edgeOfferings: edgeOfferingsReducer,
    interceptorsResponse: interceptorsResponseReducer,
    inventory: inventoryReducer,
    ixOverlays: ixOverlaysReducer,
    kexCommunity: kexCommunityReducer,
    kexProfiles: kexProfilesReducer,
    location: locationReducer,
    locations: locationsReducer,
    lockers: lockersReducer,
    mapbox: mapboxReducer,
    menus: menusReducer,
    metrics: metricsReducer,
    modalAlerts: modalAlertsReducer,
    networkInterfaces: networkInterfacesReducer,
    networkingOverview: networkingOverviewReducer,
    organizations: organizationsReducer,
    roles: rolesReducer,
    user: userReducer,
    userSettings: userSettingsReducer,
    users: usersReducer
});
export default reducers;
